import { Box, Button, Typography, Container } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const RealEstateBusiness = ({ title, description, buttonText, image, alignItems, justifyContent, textAlign, boxAlign, titleColor, descriptionColor }) => {
   const navigate = useNavigate();
  
      const handleButtonClick = () => {
          navigate("/contact"); 
      };

  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        p: 4,
      }}
    >
      <Container
        sx={{
          position: "relative",
          borderRadius: 4,
          overflow: "hidden",
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: "600px", md: "400px" },
          display: "flex",
          alignItems: alignItems || "flex-start",
          justifyContent: justifyContent || "flex-end",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            p: 4,
            mt: 2,
            mr: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: boxAlign || "flex-end",
            textAlign: textAlign || "right",
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: titleColor || "#fff" }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: descriptionColor || "#343434" }}>
            {description}
          </Typography>
          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{ borderRadius: 5, backgroundColor: "#C42776", color: "#fff" }}
            onClick={handleButtonClick}
          >
            {buttonText}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default RealEstateBusiness;